import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import ShareBar from "@/components/ShareBar";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [data, setData] = useState(null);

  useEffect(() => {
    let tries = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setData(r.data);
        if (r.data.payment_status === "paid") return setStatus("paid");
        if (["expired", "failed"].includes(r.data.payment_status)) return setStatus("failed");
      } catch {}
      if (++tries < 10) setTimeout(poll, 2000); else setStatus("timeout");
    };
    if (sessionId) poll(); else setStatus("failed");
  }, [sessionId]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <div className="max-w-lg text-center gw-card p-12" data-testid="payment-success">
        {status === "checking" && <><Loader2 className="w-12 h-12 text-[#D4AF37] animate-spin mx-auto" /><p className="mt-6 text-[#C8C4B7]">Confirming your donation…</p></>}
        {status === "paid" && <>
          <CheckCircle2 className="w-14 h-14 text-[#D4AF37] mx-auto" />
          <h1 className="font-heading text-3xl font-bold text-[#FDFBF7] mt-6">Thank You.</h1>
          <p className="mt-3 text-[#C8C4B7]">Your {data?.recurring ? "monthly " : ""}gift of ${Number(data?.amount || 0).toLocaleString()} to <b>{data?.campaign}</b> is confirmed. A receipt is on its way to your inbox.</p>
          <div className="mt-6 flex justify-center"><ShareBar title="I just supported Golden Wolf Foundation" /></div>
          <Link to="/" className="btn-gold inline-block mt-8" data-testid="success-home">Back to Home</Link>
        </>}
        {["failed", "timeout"].includes(status) && <>
          <XCircle className="w-14 h-14 text-red-400 mx-auto" />
          <h1 className="font-heading text-2xl font-bold text-[#FDFBF7] mt-6">We couldn't confirm your payment</h1>
          <p className="mt-3 text-[#C8C4B7]">If you were charged, your receipt will still arrive. Otherwise please try again.</p>
          <Link to="/donate" className="btn-outline inline-block mt-8" data-testid="success-retry">Return to Donate</Link>
        </>}
      </div>
    </div>
  );
}
